module.exports = __webpack_public_path__ + "static/media/plane(18).6b6f1540.PNG";